import { Dispatch, SetStateAction } from "react";
import { Modal } from "../../../../../components/Modal"
import { ModalFollow } from "../../ModalFollow"

interface iFollow {
    setShowFollow: Dispatch<SetStateAction<boolean>>;
    children: React.ReactNode;
    title: string
}

export const Follow = ({ setShowFollow, children, title }: iFollow) => {
    return (
        <Modal showModal={setShowFollow}>
            <ModalFollow title={title}>
                <div id="follow">
                    {children}
                </div>
            </ModalFollow>
        </Modal>
    )
}